export default "__VITE_ASSET__BYh4Nru7__"